import { getApiErrorMessage } from "@utils/apiErrorUtils";

export default function MutationError({
  show,
  error,
  fallbackMessage = "Something went wrong",
  className = "",
}) {
  if (!show) return null;
  const message = error ? getApiErrorMessage(error) : fallbackMessage;
  return (
    <p className={`text-center text-sm text-palette-red-badge ${className}`.trim()}>
      Error: {message}
    </p>
  );
}
